<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="classrooms"
        sort-by="calories"
        class="elevation-1"
        :loading="$apollo.queries.classrooms.loading"
        loading-text="Lütfen bekleyiniz"
    >
      <template v-slot:item.teachers="{ item }">
        <v-select
            :items="item.teachers"
            item-text="user.name"
            item-value="id"
        ></v-select>
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>SINIFLAR</v-toolbar-title>
          <v-divider
              class="mx-4"
              inset
              vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
              >Ekle</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <!--<v-col cols="12" sm="6" md="4">
                      <v-autocomplete v-model="editedItem.user.id" :items="users" item-text="username" item-value="id"></v-autocomplete>
                    </v-col>-->
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.name" label="Ad"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select :items="[1,2,3]" v-model.number="editedItem.grade" label="Seviye"></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete multiple v-model="editedItem.teachers" :items="teachers" item-text="user.name" item-value="id" label="Öğretmenler"></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">İptal</v-btn>
                <v-btn color="blue darken-1" text @click="save">Kaydet</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <p v-if="GraphqlError">Hata: {{ GraphqlError }}</p>
        <p v-else>Sınıf bulunamadı</p>
      </template>
    </v-data-table>
    <my-snackbar ref="snackbar"/>
  </div>

</template>

<script>
import {CLASSROOMS, TEACHERS, USERS} from '@/graphql/queries'
import {CreateClassroom, DeleteClassroom, UpdateClassroom} from '@/graphql/mutations/classroom'

import MySnackbar from "@/components/mySnackbar";


export default {
  components: {MySnackbar},

  data: () => ({
    dialog: false,
    headers: [
      {
        text: 'Ad',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Seviye', value: 'grade' },
      { text: 'Öğretmenler', value: 'teachers', sortable: false },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    GraphqlError: null,
    editedIndex: -1,
    //teacherIds: [],
    editedItem: {
      id: null,
      name: '',
      grade: 1,
      teachers: [],
    },
    defaultItem: {
      id: null,
      name: '',
      grade: 1,
      teachers: [],
    },
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Ekle' : 'Düzenle'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  apollo: {
    classrooms: {
      query: CLASSROOMS,
      error(error) {
        this.GraphqlError = JSON.stringify(error.message);
      }
    },
    teachers: {
      query: TEACHERS,
    },
    users:{
      query: USERS,
      variables: {
        userType: "NOT_ASSIGNED",
      }
    }
  },

  methods: {

    editItem (item) {
      this.editedIndex = this.classrooms.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.teachers = this.editedItem.teachers.map(teacher => teacher.id)
      this.dialog = true
    },

    async deleteItem (item) {
      const index = this.classrooms.indexOf(item)
      confirm('Silmek istediğinize emin misiniz?') && await this.deleteClassroom(index, item)
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async save () {
      if (this.editedIndex > -1) {
        await this.updateClassroom()
      } else {
        // add classroom
        await this.addClassroom()

      }
      this.close()
    },

    async addClassroom () {
      await this.$apollo.mutate({
        mutation: CreateClassroom,
        variables: {
          grade: this.editedItem.grade,
          name: this.editedItem.name,
          managerId: this.$store.getters.userCls.id,
          teachers: this.editedItem.teachers
        },
        update: (store, { data: { createClassroom } }) => {
          // add classroom
          const data = store.readQuery({ query: CLASSROOMS })
          data.classrooms.push(createClassroom.classroom)
          store.writeQuery({ query: CLASSROOMS, data })

        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    },

    async updateClassroom () {
      await this.$apollo.mutate({
        mutation: UpdateClassroom,
        variables: {
          grade: this.editedItem.grade,
          name: this.editedItem.name,
          managerId: this.$store.getters.userCls.id,
          teachers: this.editedItem.teachers,
          id: this.editedItem.id
        },
        update: (store, { data: { updateClassroom } } ) => {

          // Read the data from our cache for this query.
          const data = store.readQuery({ query: CLASSROOMS })
          // Add our tag from the mutation to the end
          data.classrooms[this.editedIndex] = updateClassroom.classroom
          // Write our data back to the cache.
          store.writeQuery({ query: CLASSROOMS, data })
        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    },

    async deleteClassroom (index, item) {
      await this.$apollo.mutate({
        mutation: DeleteClassroom,
        variables: {
          id: item.id
        },
        update: (store,) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: CLASSROOMS })
          // Add our tag from the mutation to the end
          data.classrooms.splice(index, 1)
          // Write our data back to the cache.
          store.writeQuery({ query: CLASSROOMS, data })

        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    }


  },
}
</script>


<style scoped>

</style>
